import React, { useEffect, useState } from "react";
import { GetTermsAndConditionApi } from "../../api/request/common";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { handleApiError } from "../../utils/handleApiError";

const TNC = () => {
  const [loading, setLoading] = useState(false);

  const getTNC = async () => {
    setLoading(true);
    try {
      const { data } = await GetTermsAndConditionApi();
      if (data?.success) {
        window.location.href = (data?.data[0]?.content);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { getTNC() }, []);

  if (loading) return <p className="flex items-center justify-center min-h-screen"><Spin size="large" /></p>;

  return (<></>);
};

export default TNC;
